var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelsIcon = function SvgModelsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 91,
    fill: "none",
    viewBox: "0 0 89 91"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M76.5 59a.5.5 0 0 0 1 0zm.854-19.354a.5.5 0 0 0-.708 0l-3.181 3.182a.5.5 0 1 0 .707.707L77 40.707l2.828 2.828a.5.5 0 1 0 .707-.707zM77.5 59V40h-1v19zM15.5 40a.5.5 0 0 0-1 0zm-.854 19.354a.5.5 0 0 0 .708 0l3.182-3.182a.5.5 0 1 0-.708-.707L15 58.293l-2.828-2.828a.5.5 0 1 0-.708.707zM14.5 40v19h1V40zM36 78.5a.5.5 0 0 0 0 1zm19.354.854a.5.5 0 0 0 0-.708l-3.182-3.181a.5.5 0 1 0-.707.707L54.293 79l-2.828 2.828a.5.5 0 1 0 .707.707zM36 79.5h19v-1H36zM55 13.5a.5.5 0 0 0 0-1zm-19.354-.854a.5.5 0 0 0 0 .708l3.182 3.182a.5.5 0 1 0 .707-.708L36.707 13l2.828-2.828a.5.5 0 1 0-.707-.708zM55 12.5H36v1h19z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 14,
    x: 3.5,
    y: 71.5,
    fill: "#E5E5FE",
    stroke: "#3D4355",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 5,
    x: 0.5,
    y: 85.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "m66.767 26.488 6.733-11.48h7l6.362 11.525c.736 1.333-.228 2.967-1.75 2.967h-16.62c-1.546 0-2.507-1.679-1.725-3.012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    d: "m66.767 26.488 6.733-11.48V1h7v14.009l6.362 11.524c.736 1.333-.228 2.967-1.75 2.967h-16.62c-1.546 0-2.507-1.679-1.725-3.012Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M72 1h10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    stroke: "#3D4355",
    d: "M65.5 70a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v20.5h-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    fillOpacity: 0.6,
    stroke: "#3D4355",
    d: "M74.5 75a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v15.5h-6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    fillOpacity: 0.2,
    stroke: "#3D4355",
    d: "M83.5 82a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v8.5h-5z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 26,
    x: 2,
    y: 4,
    fill: "#E5E5FE",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 25,
    x: 5.5,
    y: 1.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 11-3 3 3 3M21 17l3-3-3-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "m18 10-3 8"
  })));
};
export default SvgModelsIcon;